import {
  Component,
  input,
  InputSignal,
  model,
  ModelSignal
} from '@angular/core';
import { SidebarPosition } from '../../../enums/sidebar-wrapper.enum';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-sidebar-wrapper',
  imports: [NgClass],
  templateUrl: './sidebar-wrapper.component.html',
  styleUrl: './sidebar-wrapper.component.scss'
})
export class SidebarWrapperComponent {
  isOpen: ModelSignal<boolean> = model.required<boolean>();
  position: InputSignal<SidebarPosition> = input<SidebarPosition>(
    SidebarPosition.Left
  );

  onCloseClick(): void {
    this.isOpen.set(false);
  }
}
